import { formatCurrency, KeyValue } from '@angular/common';

import {
	AfterViewInit,
	Component,
	ElementRef,
	OnInit,
	ViewChild,
} from '@angular/core';

import { FormBuilder, Validators } from '@angular/forms';

import { Title } from '@angular/platform-browser';

import { ReplaySubject, takeUntil } from 'rxjs';

import {
	AppDisplayBlockService,
	BannerModel,
	CardModel
} from 'dd1pnds-ngx-libs';

import {
	Dd1pndsNgRedirectionService,
	Dd1pndsNgStatistiquesService,
	EnumClickType,
} from 'dd1pnds-ngx-services';

import { MappingEventStatistiques } from '../../configs/mapping-event-statistiques.enum';

import { RoutesConfig } from '../../configs/routes.config';

import {
	buildRadioButtonModel,
	FaqSectionModel,
	FormFieldDescriptionModel,
} from '../../shared/models/landing-page/faq/faq.model';

import {
	BandeauModel,
	FormulaireModel,
} from '../../shared/models/landing-page/landing-page.model';

import {
	ORGANISMES,
	StatistiquesChampCombienEnfants,
	StatistiquesChampCombienSalaire,
} from '../../shared/models/utils.enum';

import { AvvcCmsService } from '../../shared/services/avvc-cms/avvc-cms.service';

import { CalculMontantAvvcService } from '../../shared/services/calcul-montant-avvc/calcul-montant-avvc.service';

@Component({
	selector: 'landing-page-avvc',
	templateUrl: './landing-page-avvc.component.html',
	styleUrls: ['./landing-page-avvc.component.scss'],
})
export class LandingPageAvvcComponent implements OnInit, AfterViewInit {
	private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

	@ViewChild('sectionFormulaireEligibilite') formulaireEligibilite: ElementRef;
	@ViewChild('accordeonQuiPeutBeneficierAvvc', { read: ElementRef }) accordeonBeneficiaire: ElementRef;

	eventsStats = MappingEventStatistiques;

	shouldDisplay: boolean;
	contentLoaded = false;

	bandeauContenu: BandeauModel;

	faqContent: Record<string, FaqSectionModel>;
	montantAvvcForm = this.fb.group({
		combienEnfants: [
			null as string,
			{
				validators: [Validators.required],
			},
		],
		nbEnfants: this.fb.control(
			{ value: null as number, disabled: true },
			{
				validators: [
					Validators.required,
					Validators.min(0),
					Validators.max(20),
					Validators.pattern('\\d{1,2}'),
				],
			}
		),
		combienSalaire: [
			null as string,
			{
				validators: [Validators.required],
			},
		],
	});
	/** Indique si le bouton de calcul du montant a été cliqué au moins une fois */
	isBoutonCalculMontantClique = false;

	banniereFormAvvc: BannerModel;
	alerteMontantAvvc: BannerModel;
	displayAlerteMontantAvvc = false;
	isFaqBeneficierExpanded: [boolean] = [false];

	eligibiliteAvvcContent: FormulaireModel;
	eligibiliteAvvcForm = this.fb.group({
		residence: [null as boolean, { validators: [Validators.required] }],
		statut: this.fb.control(
			{ value: null as boolean, disabled: true },
			{ validators: [Validators.required] }
		),
		justificatif: this.fb.control(
			{ value: null as boolean, disabled: true },
			{ validators: [Validators.required] }
		),
		organisme: this.fb.control(
			{ value: null as string, disabled: true },
			{ validators: [Validators.required] }
		),
	});

	alerteEligibiliteAvvc: BannerModel;
	boutonEligibiliteAvvc: string;
	isEligibleAvvc: boolean;
	isNonEligibleAvvc: boolean;

	cartesPartenairesTitre: string;
	cartesPartenaires: CardModel[];

	labelErrorTitle: string;
	labelErrorExplanation: string;
	errorImg: string;

	constructor(
		private appDisplayBlockService: AppDisplayBlockService,
		private statistiquesService: Dd1pndsNgStatistiquesService,
		private redirectionService: Dd1pndsNgRedirectionService,
		private titleService: Title,
		private avvcCms: AvvcCmsService,
		private fb: FormBuilder
	) { }

	ngOnInit(): void {
		this.titleService.setTitle(RoutesConfig.routesTitles.accueil);
		this.avvcCms.loadCmsAvvcData().subscribe({
			next: () => {
				this._initBandeauContent();
				this._initFAQContent();
				this._initEligibiliteAvvcContent();
				this._initCartesContent();
			},
			error: (error) => {
				console.error('Error on content load : ', error);
			},
			complete: () => (this.contentLoaded = true),
		});

		this._initFormMontantListeners();
		this._initFormEligibiliteListeners();

		this.shouldDisplay = this.appDisplayBlockService.onDisplayed(
			this.appDisplayBlockService.windowWidth
		);
	}

	ngAfterViewInit(): void {
		this.statistiquesService.sendPage(
			MappingEventStatistiques.pageAccueil,
			null,
			null
		);
	}

	onResizeChange(event: any): void {
		this.isDisplayed(event);
	}

	isDisplayed(event: any): void {
		this.shouldDisplay = this.appDisplayBlockService.onDisplayed(
			event.innerWidth
		);
	}

	goToFormulaireEligibilite(): void {
		this.statistiquesService.sendClick(
			MappingEventStatistiques.clicDemandeAide,
			null,
			null,
			EnumClickType.action
		);
		this._scrollIntoElementView(this.formulaireEligibilite);
	}

	redirectToPage(url: string, eventStat: string = null): void {
		this.redirectionService.manageRedirectPage(url);
		if (eventStat) {
			this.statistiquesService.sendClick(
				eventStat,
				null,
				null,
				EnumClickType.navigation
			);
		}
	}

	/**
	 * Send a statistic event for a click, by default for a click resulting in an action.
	 *
	 * @param eventStat The statistict event identificator.
	 * @param clickType The type of click : action, navigation, etc. By default takes the value "action".
	 */
	sendClickStat(
		eventStat: string = null,
		clickType: EnumClickType = EnumClickType.action
	): void {
		this.statistiquesService.sendClick(eventStat, null, null, clickType);
	}

	sortOrder(
		a: KeyValue<string, FormFieldDescriptionModel>,
		b: KeyValue<string, FormFieldDescriptionModel>
	): number {
		return a.value.order - b.value.order;
	}

	onClickCalculerMontantButton(): void {
		this.isBoutonCalculMontantClique = true;
		if (this.montantAvvcForm.valid) {
			const values = this.montantAvvcForm.value;
			this._calculerMontantAide(
				values.combienEnfants,
				values.combienSalaire,
				values.nbEnfants
			);
			this.displayAlerteMontantAvvc = true;
		}
	}

	preparerBanniereEligibiliteOrganisme(
		organisme: string,
		banniere: BannerModel
	): void {
		this.alerteEligibiliteAvvc = { ...banniere };
		this.alerteEligibiliteAvvc.content = [...banniere.content];
		const mess = this.alerteEligibiliteAvvc.content[1];

		const organismeStr =
			ORGANISMES[organisme].libelle +
			ORGANISMES[organisme].libelleComplement;
		this.alerteEligibiliteAvvc.content[1] = mess.replace(
			'#organisme',
			organismeStr
		);
	}

	preparerBoutonEligibiliteOrganisme(
		organisme: string,
		boutonLibelle: string
	): void {
		const organismeStr = ORGANISMES[organisme].libelle;
		this.boutonEligibiliteAvvc = boutonLibelle.replace(
			'#organisme',
			organismeStr
		);
	}

	scrollIntoAndOpenAccordeon(
		accordeon: ElementRef,
		isAccordeonOuvert: [boolean]
	): void {
		this._scrollIntoElementView(accordeon);
		if (!isAccordeonOuvert[0]) {
			isAccordeonOuvert[0] = true;
		}
	}

	faireDemandeAvvc(): void {
		this.statistiquesService.sendClick(
			MappingEventStatistiques.clicBoutonFaireDemande,
			null,
			null,
			EnumClickType.action
		);
		const organisme = this.eligibiliteAvvcForm.value.organisme;
		this.redirectToPage(ORGANISMES[organisme].url);
	}

	onChangeResidenceSendStat(value: boolean) {
		if (value) {
			this.sendClickStat(MappingEventStatistiques.clicChampResidenceOui);
		} else {
			this.sendClickStat(MappingEventStatistiques.clicChampResidenceNon);
		}
	}

	onChangeStatutSendStat(value: boolean) {
		if (value) {
			this.sendClickStat(MappingEventStatistiques.clicChampStatutOui);
		} else {
			this.sendClickStat(MappingEventStatistiques.clicChampStatutNon);
		}
	}

	onChangeJustificatifSendStat(value: boolean) {
		if (value) {
			this.sendClickStat(
				MappingEventStatistiques.clicChampJustificatifOui
			);
		} else {
			this.sendClickStat(
				MappingEventStatistiques.clicChampJustificatifNon
			);
		}
	}

	onChangeOrganismeSendStat(value: string) {
		this.sendClickStat(ORGANISMES[value].stat);
	}

	onChangeNbEnfants(value: number) {
		if (this.montantAvvcForm.controls.nbEnfants.valid) {
			this.statistiquesService.sendClick(
				MappingEventStatistiques.clicChampCombienEnfants + ' ' + value,
				null,
				null,
				EnumClickType.action
			);
		}
	}

	private _calculerMontantAide(
		champEnfants: string,
		champMontant: string,
		nbEnfants: number
	): void {
		this.alerteMontantAvvc = { ...this.banniereFormAvvc };
		this.alerteMontantAvvc.content = [...this.banniereFormAvvc.content];

		this.alerteMontantAvvc.content = this.alerteMontantAvvc.content.map(
			(mess) => {
				let res = mess;
				if (mess.indexOf('#montant') >= 0) {
					const montant =
						CalculMontantAvvcService.calculerMontantAvvc(
							champEnfants,
							champMontant,
							nbEnfants
						);
					res = mess.replace(
						'#montant',
						formatCurrency(montant, 'fr-FR', '€', null, '1.0-0')
					);
				} else if (mess.indexOf('#natureAide') >= 0) {
					const natureAide =
						CalculMontantAvvcService.determinerNatureAideString(
							champEnfants,
							champMontant,
							nbEnfants
						);
					res = mess.replace('#natureAide', natureAide);
				}
				return res;
			}
		);
	}

	/**
	 * Initializes the page content.
	 */
	private _initCartesContent(): void {
		this.cartesPartenairesTitre = this.avvcCms.getCartesPartenairesTitre();
		this.cartesPartenaires = this.avvcCms.getCartesPartenaires();
	}

	private _initBandeauContent(): void {
		this.bandeauContenu = this.avvcCms.getBandeauContent();
	}

	private _initFAQContent(): void {
		this.faqContent = this.avvcCms.getFaqContent();

		// On ajoute le reste des informations concernant les questions des formulaires
		const form = this.faqContent.montant.reponses
			.filter((faqRep) => faqRep.type === 'formulaire')
			.at(0);
		this.banniereFormAvvc = form.bannerContent;
		form.formGroup = this.montantAvvcForm;
		const champsForm = form.contenu as Record<
			string,
			FormFieldDescriptionModel
		>;

		// Les informations complémentaires du champ sur le nombre d'enfants
		champsForm.combienEnfants.order = 0;
		champsForm.combienEnfants.nomHtml = 'nombre-enfants';
		champsForm.combienEnfants.choices = [
			buildRadioButtonModel('aucunEnfant', 'Aucun enfant'),
			buildRadioButtonModel('1Enfant', '1 enfant'),
			buildRadioButtonModel('2Enfants', '2 enfants'),
			buildRadioButtonModel('3Enfants', '3 enfants'),
			buildRadioButtonModel('4+Enfants', '4 enfants ou plus'),
		];

		// Les informations complémentaires du champ de saisie pour le nombre d'enfants
		champsForm.nbEnfants.order = 1;
		champsForm.nbEnfants.nomHtml = 'nombre-enfants-input';

		// Les informations complémentaires du champ sur le montant du salaire
		champsForm.combienSalaire.order = 2;
		champsForm.combienSalaire.nomHtml = 'montant-salaire';
		champsForm.combienSalaire.choices = [
			buildRadioButtonModel('smic1', 'Moins de 713 €'),
			buildRadioButtonModel('smic2', 'Entre 713 et 1426 €'),
			buildRadioButtonModel('smic3', 'Entre 1427 et 2139 €'),
			buildRadioButtonModel('smic4', 'Entre 2140 et 3209 €'),
			buildRadioButtonModel('smic5', 'Entre 3210 et 3851 €'),
			buildRadioButtonModel('smic6', 'Entre 3852 et 4707 €'),
			buildRadioButtonModel('smic7', 'Plus de 4707 €'),
		];
	}

	private _initEligibiliteAvvcContent(): void {
		this.eligibiliteAvvcContent =
			this.avvcCms.getFormulaireEligibiliteContent();

		// On ajoute le reste des informations concernant les questions des formulaires
		// On ajoute les informations pour la question sur le lieu de résidence
		const residence = this.eligibiliteAvvcContent.questions['residence'];
		residence.htmlName = 'choix-resident';
		residence.controlName = 'residence';
		residence.style = 'ligne';
		residence.choices = [
			{
				value: true,
				label: 'Oui',
			},
			{
				value: false,
				label: 'Non',
			},
		];

		const statut = this.eligibiliteAvvcContent.questions['statut'];
		statut.htmlName = 'choix-statut';
		statut.controlName = 'statut';
		statut.style = 'ligne';
		statut.choices = [
			{
				value: true,
				label: 'Oui',
			},
			{
				value: false,
				label: 'Non',
			},
		];

		const justificatif =
			this.eligibiliteAvvcContent.questions['justificatif'];
		justificatif.htmlName = 'choix-justificatif';
		justificatif.controlName = 'justificatif';
		justificatif.style = 'ligne';
		justificatif.choices = [
			{
				value: true,
				label: 'Oui',
			},
			{
				value: false,
				label: 'Non',
			},
		];

		const organisme = this.eligibiliteAvvcContent.questions['organisme'];
		organisme.htmlName = 'choix-organisme';
		organisme.controlName = 'organisme';
		organisme.style = 'colonne';
		organisme.choices = [
			{
				value: 'msa',
				label: 'MSA',
			},
			{
				value: 'caf',
				label: 'CAF',
			},
			{
				value: 'autre',
				label: 'Autre / Je ne sais pas',
			},
		];
	}

	/**
	 * Initialise les listeners sur les changements de valeur des champs du formulaire sur le montant de l'aide
	 */
	private _initFormMontantListeners() {
		this.montantAvvcForm.controls.combienEnfants.valueChanges
			.pipe(takeUntil(this.destroyed$))
			.subscribe((value) => {
				this.statistiquesService.sendClick(
					MappingEventStatistiques.clicChampCombienEnfants +
					' ' +
					StatistiquesChampCombienEnfants[value],
					null,
					null,
					EnumClickType.action
				);
				if (value === '4+Enfants') {
					this.montantAvvcForm.controls.nbEnfants.enable({
						emitEvent: false,
					});
				} else {
					this.montantAvvcForm.controls.nbEnfants.disable({
						emitEvent: false,
					});
				}
			});

		this.montantAvvcForm.controls.combienSalaire.valueChanges
			.pipe(takeUntil(this.destroyed$))
			.subscribe((value) => {
				this.statistiquesService.sendClick(
					MappingEventStatistiques.clicChampCombienSalaire +
					' ' +
					StatistiquesChampCombienSalaire[value],
					null,
					null,
					EnumClickType.action
				);
			});
	}

	private _initFormEligibiliteListeners() {
		this.eligibiliteAvvcForm.controls.residence.valueChanges
			.pipe(takeUntil(this.destroyed$))
			.subscribe((value) => {
				if (
					value === true &&
					this.eligibiliteAvvcForm.controls.statut.disabled === true
				) {
					this.eligibiliteAvvcForm.controls.statut.enable();
				} else if (
					value === false &&
					this.eligibiliteAvvcForm.controls.statut.disabled === false
				) {
					this.eligibiliteAvvcForm.controls.statut.disable();
				}
			});

		this.eligibiliteAvvcForm.controls.statut.valueChanges
			.pipe(takeUntil(this.destroyed$))
			.subscribe((value) => {
				if (
					value === true &&
					this.eligibiliteAvvcForm.controls.justificatif.disabled ===
					true
				) {
					this.eligibiliteAvvcForm.controls.justificatif.enable();
				} else if (
					value === false &&
					this.eligibiliteAvvcForm.controls.justificatif.disabled ===
					false
				) {
					this.eligibiliteAvvcForm.controls.justificatif.disable();
				}
			});

		this.eligibiliteAvvcForm.controls.statut.statusChanges
			.pipe(takeUntil(this.destroyed$))
			.subscribe((status) => {
				if (status === 'DISABLED') {
					this.eligibiliteAvvcForm.controls.justificatif.disable();
				}
			});

		this.eligibiliteAvvcForm.controls.justificatif.valueChanges
			.pipe(takeUntil(this.destroyed$))
			.subscribe((value) => {
				if (
					value === true &&
					this.eligibiliteAvvcForm.controls.organisme.disabled ===
					true
				) {
					this.eligibiliteAvvcForm.controls.organisme.enable();
				} else if (
					value === false &&
					this.eligibiliteAvvcForm.controls.organisme.disabled ===
					false
				) {
					this.eligibiliteAvvcForm.controls.organisme.disable();
				}
			});

		this.eligibiliteAvvcForm.controls.justificatif.statusChanges
			.pipe(takeUntil(this.destroyed$))
			.subscribe((status) => {
				if (status === 'DISABLED') {
					this.eligibiliteAvvcForm.controls.organisme.disable();
				}
			});

		this.eligibiliteAvvcForm.valueChanges
			.pipe(takeUntil(this.destroyed$))
			.subscribe((values) => {
				const bloquants = [
					values.residence,
					values.statut,
					values.justificatif,
				];
				this.isNonEligibleAvvc = bloquants.some(
					(item) => item === false
				);
				if (values.organisme !== null) {
					this.isEligibleAvvc =
						values.residence &&
						values.statut &&
						values.justificatif;
				}
			});
	}

	/**
	 * Scrolls to the specified element.
	 * @param el - The element
	 */
	private _scrollIntoElementView(el: any): void {
		// Si l'élément est renseigné
		if (el) {
			// Alors je scroll sur l'element
			el.nativeElement.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		}
	}
}
